import { AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { IndirectUploadZoneComponent } from '../../../../../shared/form/element/indirect-upload-zone/indirect-upload-zone.component';
import { CampaignId } from '../../../../campaign-util/shared/campaign-id';
import { PhotocodeTemplateForm } from './photocode-template.form';
import { AbstractPresetFormComponent } from '../../preset-form.component';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute, Router } from '@angular/router';
import { EventBus } from '../../../../../shared/event/bus';
import { CampaignUrlBuilder } from '../../../../campaign-util/shared/url-builder';
import { AdminUrlBuilder } from '../../../../../shared/admin/api/admin-url-builder';
import { ErrorCodes } from '../../../../../shared/enum/api-errors';


@Component({
  selector: 'admin-photocode-template-form',
  templateUrl: './form.component.html',
  styleUrls: [ './form.component.scss' ]
})
export class AdminPhotocodeTemplateFormComponent extends AbstractPresetFormComponent implements OnInit, AfterViewInit {

  @ViewChild('templateUploader', { static: false })
  protected templateUploader: IndirectUploadZoneComponent;
  @ViewChild('watermarkUploader', { static: false })
  protected watermarkUploader: IndirectUploadZoneComponent;
  @ViewChild('fontUploader', { static: false })
  protected fontUploader: IndirectUploadZoneComponent;
  @ViewChild('logoUploader', { static: false })
  protected logoUploader: IndirectUploadZoneComponent;

  @ViewChild('editor', { static: true })
  protected editor: ElementRef;
  protected form: FormGroup;

  @Input()
  row: any;
  photocodeTemplate: any = {};

  templateImage: any;
  watermarkImage: any;
  fontFile: any;
  logoFile: any;

  loading: boolean = false;
  makeDefault: any;

  constructor(formBuilder: PhotocodeTemplateForm,
              httpClient: HttpClient,
              toastrService: ToastrService,
              crudUrlBuilder: AdminUrlBuilder,
              private campaignUrlBuilder: CampaignUrlBuilder,
              router: Router,
              route: ActivatedRoute,
              campaignId: CampaignId,
              eventBus: EventBus) {
    super(formBuilder, httpClient, toastrService, crudUrlBuilder, router, route, campaignId, eventBus);
  }

  ngOnInit(): void {
    // this.submitListener.subscribe(
    //   (response: any) => this.onSubmit(response)
    // );
    this.formMode = this.row ? 'update' : 'create';
    this.form = this.formBuilder.buildForm(this.formMode === 'update');

    this.form = this.formBuilder.buildForm();
    this.form.controls.name.patchValue('Photocode template');
    if (this.route.snapshot.params.id) {
    }
    if (this.row) {
      this.load(this.row.id);
    }
  }

  load(id: number) {
    this.loading = true;
    let url = this.getUrl(id);
    if (this.urlBuilder) {
      url = this.urlBuilder.buildUrl(url);
    }
    this.httpClient.get<any>(url)
      .subscribe(
        (data: any) => {
          this.photocodeTemplate = data;
          // this.row = { ...this.row, ...data };
          this.row.createDate = data.createDate;
          this.row.name = data.name;
          this.form.patchValue(data);
          this.loading = false;
        },
        (error: any) => {
          this.toastrService.error(error.error ? (error.error.message || ErrorCodes[error.error.code] || 'Something went wrong...') : 'Error');
          this.loading = false;
        }
      );
  }

  ngAfterViewInit() {
  }

  getUrl(forceId?: number): string {
    const params = this.route.snapshot.params;
    return '/photocode-template' + (params.id ? `/${params.id}` : forceId ? `/${forceId}` : '');
  }

  onFontUploaded(fontFile: any) {
    this.photocodeTemplate.fontFileName = fontFile.fileName;
    this.photocodeTemplate.fontS3 = fontFile.s3;
  }

  onTemplateUploaded(templateFile) {
    this.photocodeTemplate.templateFileName = templateFile.fileName;
    this.photocodeTemplate.templateS3 = templateFile.s3;
  }

  onWatermarkUploaded(watermarkFile) {
    this.photocodeTemplate.watermarkFileName = watermarkFile.fileName;
    this.photocodeTemplate.watermarkS3 = watermarkFile.s3;
  }

  onLogoUploaded(logoFile) {
    this.photocodeTemplate.logoFileName = logoFile.fileName;
    this.photocodeTemplate.logoS3 = logoFile.s3;
  }

  cancelWatermark() {
    this.photocodeTemplate.watermarkFileName = false;
    this.watermarkImage = false;
  }

  cancelTemplate() {
    this.photocodeTemplate.templateFileName = false;
    this.templateImage = false;
  }

  cancelFont() {
    this.photocodeTemplate.fontFileName = false;
    this.fontFile = false;
  }

  cancelLogo() {
    this.photocodeTemplate.logoFileName = false;
    this.logoFile = false;
  }

  submit(): void {
    if (!this.form.controls.name.value) {
      this.toastrService.error('Enter name');
      return;
    }
    if (!this.photocodeTemplate.templateFileName) {
      this.toastrService.error('Upload template');
      return;
    }
    if (!this.photocodeTemplate.watermarkFileName) {
      this.toastrService.error('Upload watermark');
      return;
    }
    if (!this.photocodeTemplate.fontFileName) {
      this.toastrService.error('Upload font');
      return;
    }
    const url = this.urlBuilder.buildUrl(this.getUrl(this.photocodeTemplate.id));
    const method = typeof this.photocodeTemplate.id === 'undefined' ? this.httpClient.post : this.httpClient.put;
    this.savePromise = method.call(this.httpClient, url, {
      ...this.form.value,
      templateFileName: this.photocodeTemplate.templateFileName,
      watermarkFileName: this.photocodeTemplate.watermarkFileName,
      fontFileName: this.photocodeTemplate.fontFileName,
      logoFileName: this.photocodeTemplate.logoFileName,
    })
      .subscribe((response: any) => {
        this.photocodeTemplate.id = response.id;
        this.toastrService.success('Saved');
        this.row.__editing = false;
        this.row.id = response.id;
        this.load(this.row.id);
        return response;
      }, (error: any) => {
        this.toastrService.error(error.error ? (error.error.message || ErrorCodes[error.error.code] || 'Something went wrong...') : 'Error');
        return error;
      });
  }
}
